export const FETCH_PRODUCT_MASTER_DDL = 'FETCH_PRODUCT_MASTER_DDL';
export const FETCH_INVOICE_MASTER_DDL = 'FETCH_INVOICE_MASTER_DDL';
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCT_DETAILS = 'FETCH_PRODUCT_DETAILS';
